module.exports = __webpack_public_path__ + "static/media/brd.5515dd2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/partners/brd.png
// module id = 254
// module chunks = 0